import { appInsight, collectProperties } from 'components/appInsight';
import { Icon, IconsEnum } from 'components/Icons';
import { useInfoTemplateAvvenimento } from 'features/sport/hooks';
import { useTranslation } from 'hooks/useLingUI';
import React, { useEffect } from 'react';
import { SportsCacheTemplateAvvenimentoDto } from 'types/swagger';
import { isTruthy } from 'utility/functions';
import { VideoStreamingMode } from '../liveVideoStreaming';
import { useLiveStreaming } from '../liveVideoStreaming/useLiveStreaming';
import styles from './LiveVideoStreamingContainer.module.scss';

export const LiveVideoStreamingContainer = () => {
  const { t } = useTranslation();

  const { templateAvvenimento } = useInfoTemplateAvvenimento<SportsCacheTemplateAvvenimentoDto>();

  const { isEmpty, isError, isLoading, streamingMode, setStreamingMode } = useLiveStreaming({
    idProgramma: `${templateAvvenimento?.idProgramma}`,
    hasStreaming: isTruthy(templateAvvenimento?.live?.hasStreaming),
    idAvvenimento: `${templateAvvenimento?.idAvvenimento}`,
    betRadarMatchId: `${templateAvvenimento?.live?.betRadarMatchId}`,
    betGeniusMatchId: `${templateAvvenimento?.live?.betGeniusMatchId}`,
  });

  useEffect(() => {
    appInsight?.trackTrace({
      message: '[LiveVideoStreamingContainer] Unable to obtain streaming video due missing live data',
      properties: collectProperties(false, {
        live: templateAvvenimento?.live,
        slug: templateAvvenimento?.slug,
      }),
    });
  }, [templateAvvenimento?.live, templateAvvenimento?.slug]);

  if (streamingMode === VideoStreamingMode.modal) {
    return null;
  }
  return (
    !isError &&
    !isEmpty && (
      <div className={styles.streamingActionContainer}>
        <button
          disabled={isLoading}
          onClick={() =>
            setStreamingMode(
              streamingMode === VideoStreamingMode.expanded ? VideoStreamingMode.minimal : VideoStreamingMode.expanded
            )
          }
        >
          <Icon iconId={IconsEnum.STREAMING} className={styles.icon} />
          {streamingMode === VideoStreamingMode.expanded
            ? t('reduce-player-streaming', '#reduce-player-streaming')
            : t('extend-player-streaming', '#extend-player-streaming')}
        </button>

        <button disabled={isLoading} onClick={() => setStreamingMode(VideoStreamingMode.modal)}>
          <Icon iconId={IconsEnum.STREAMING} className={styles.icon} />
          {t('popup-video-streaming', '#popup-video-streaming')}
        </button>
      </div>
    )
  );
};
